import React from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../features/user/UserSlice';

import { Route, Redirect } from 'react-router-dom';


function AuthRoute({ component: Component, ...rest }) {
    const { username } = useSelector(userSelector);

    return (
        <Route
            {...rest}
            render={props =>
                username ? <Component {...props} /> : <Redirect to='/' />
            }
        />
    );
}

export default AuthRoute;